import { ContactInfoStatusValue } from "../interfaces/ContactInfoInterfaces.mjs";
import React from "react";
import { Grid, GridColumn, Tooltip, TooltipToggle, Icon } from "telia-front-react";
import { getAddressAsText } from "./AddressUtil.mjs";
const getMissingContactInfoName = (contactInfoStatuses) => {
  let missingContactInfoName;
  Object.entries(contactInfoStatuses).forEach((entry) => {
    if (entry[0] !== "general" && contactInfoStatuses[entry[0]].includes(ContactInfoStatusValue.MISSING)) {
      missingContactInfoName = entry[0];
    }
  });
  return missingContactInfoName;
};
const getAllContactInfoStatuses = (contactInfoStatuses) => {
  const { email, phone, address } = contactInfoStatuses;
  return [email, phone, address].flat();
};
const canConfirmInformation = (contactInfoStatuses) => {
  const { general } = contactInfoStatuses;
  return getAllContactInfoStatuses(contactInfoStatuses).every((status) => status === ContactInfoStatusValue.OK) && general === "OLD";
};
const renderContactInfoFields = (userInfo, contactInfoStatuses, contactAddress, translate, validateAddress) => {
  const isInfoValidated = (infoStatuses) => {
    return infoStatuses.includes(ContactInfoStatusValue.OK);
  };
  const renderContactInfoField = (fieldName, value, translate2, validated) => {
    const getFieldValue = () => {
      const missingIcon = /* @__PURE__ */ React.createElement(Icon, { modifiers: "#alert", align: "middle", className: "text-error", size: "xs" });
      if (!validated) {
        return /* @__PURE__ */ React.createElement(Grid, { element: "span", align: ["top-xs"], horizontalGutter: "xsmall" }, !!value && /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-10", value.length > 25 ? "min-lg" : "min-sm"] }, /* @__PURE__ */ React.createElement(Tooltip, { referenceElement: /* @__PURE__ */ React.createElement(TooltipToggle, { id: "tooltip-toggle" }, value) }, translate2("dataconfirm.validationcheck.tooltip.".concat(fieldName))), " "), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-2", "min-sm"] }, missingIcon));
      }
      return value || missingIcon;
    };
    return /* @__PURE__ */ React.createElement("div", { className: "text__margin-half" }, /* @__PURE__ */ React.createElement(Grid, { element: "span", align: ["top-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-5", "lg-3"] }, translate2("common.contactInfo.".concat(fieldName))), /* @__PURE__ */ React.createElement(GridColumn, { width: ["xs-7", "lg-9"], className: "text-bold text-break" }, getFieldValue())));
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderContactInfoField("phone", userInfo.phone, translate, isInfoValidated(contactInfoStatuses.phone)), renderContactInfoField("email", userInfo.email, translate, isInfoValidated(contactInfoStatuses.email)), renderContactInfoField("address", getAddressAsText(contactAddress), translate, validateAddress ? isInfoValidated(contactInfoStatuses.address) : true), renderContactInfoField("communicationLanguage", translate("common.language.".concat(userInfo.communicationLanguageCode.toLowerCase())), translate, true));
};
export {
  canConfirmInformation,
  getAllContactInfoStatuses,
  getMissingContactInfoName,
  renderContactInfoFields
};
